import { AdvertiserDomainSelect } from "advertiser/components/AdvertiserDomainSelect"
import { getObjectProperty } from "app/tools/common"
import { checkTouched, isTouched as hasBeenTouched } from "form/tools/validation"
import { Field, FieldProps } from "formik"
import React from "react"

interface IFieldSelectAdvertiserDomainProps {
  fieldName: string
  disabled?: boolean
  required?: boolean
  error?: string
  sx?: any
}

export const FieldSelectAdvertiserDomain = React.memo(
  ({ disabled, error, fieldName, required, sx }: IFieldSelectAdvertiserDomainProps): JSX.Element => (
    <Field name={fieldName}>
      {({ form: { touched, values, setFieldValue } }: FieldProps) => {
        const isTouched: boolean = hasBeenTouched(touched, fieldName)
        const selectedAdvertiserIds = getObjectProperty(values, fieldName)
        return (
          <AdvertiserDomainSelect
            id="advertiser-domain-select"
            required={required}
            disabled={disabled}
            error={isTouched ? error || "" : ""}
            defaultSelectedEntityIds={selectedAdvertiserIds}
            minFilterLength={0}
            onChange={newAvertiserDomains => {
              if (!isTouched) {
                checkTouched(touched, fieldName)
              }
              const newAvertiserDomainIds = newAvertiserDomains.map(a => a.id)
              setFieldValue(fieldName, newAvertiserDomainIds)
            }}
            onBlur={() => {
              if (!isTouched) {
                checkTouched(touched, fieldName)
                setFieldValue(fieldName, selectedAdvertiserIds)
              }
            }}
            sx={sx}
          />
        )
      }}
    </Field>
  )
)
